export { default as Register } from './Register';
export { default as Login } from './Login';
export { default as VerifyOTP } from './VerifyOTP';
export { default as ForgotPassword } from './ForgotPassword';
export { default as ResetPassword } from './ResetPassword';
